import * as styles from './styles';

export const Spinner = () => (
  <div className={styles.spinner} data-testid="field-spinner" data-cy="field-spinner" aria-label="Loading" />
);
